import React, { useEffect, useState, useContext } from "react";
import { Redirect, withRouter, Link } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

import { subirArchivo } from "../../utils/utilidadesArchivos";
import AuthContext from "../../context/AuthContext";
import useObtenerUsuario from "../../utils/useObtenerUsuario";
import useObtenerMunProp from "../../utils/useObtenerMunProp";

import MPage from "../templates/mpage";
import FormInput from "../components/forminput";
import FormTextArea from "../components/formtextarea";
import EliminarPropuesta from "../components/eliminarpropuesta";

const AdminPropuesta = (props) => {
  const { loggedIn } = useContext(AuthContext);
  const [usuario, errorUsuario] = useObtenerUsuario(loggedIn);
  const [municipio, propuesta, errorMunProp] = useObtenerMunProp(
    usuario,
    props.match.params.id
  );

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  const [imagen, guardarImagen] = useState("");
  const [documento, guardarDocumento] = useState("");

  useEffect(() => {
    if (propuesta !== undefined) {
      const incializarForm = (propuesta) => {
        const camposPropuesta = Object.keys(propuesta);
        const camposAEliminar = [
          "doc",
          "img",
          "_id",
          "municipioId",
          "fecha",
          "observaciones",
          "__v",
          "observaciones",
        ];
        const camposFormulario = camposPropuesta.filter((campo) => {
          return !camposAEliminar.includes(campo);
        });
        for (const campo of camposFormulario) {
          setValue(campo, propuesta[campo], { shouldValidate: true });
        }
      };
      incializarForm(propuesta);
    }
  }, [propuesta, setValue]);

  //Guarda la imagen cargada en el formulario
  const actualizarImagen = (e) => {
    guardarImagen(e.target.files[0]);
  };

  //Guarda el documento cargado en el formulario
  const actualizarDocumento = (e) => {
    guardarDocumento(e.target.files[0]);
  };

  const onFormSubmit = (data) => {
    data["observaciones"] = propuesta.observaciones;
    if (data.obs !== "") {
      const observacion = {
        mensaje: data.obs,
        fecha: new Date().toLocaleDateString(),
      };
      data["observaciones"].unshift(observacion);
      delete data.obs;
    }

    //Subo la imagen al server
    data["img"] = propuesta.img;
    if (imagen.size > 0) {
      const nuevoNombre = subirArchivo(imagen);
      if (nuevoNombre === null) {
        Swal.fire(
          "Ocurrio error al subir la imagen de la propuesta, intente de nuevo."
        );
        return;
      }
      data["img"] = nuevoNombre;
    }

    //Subo el documento adjunto al servidor
    data["doc"] = propuesta.doc;
    if (documento !== "") {
      const nuevoNombre = subirArchivo(documento);
      if (nuevoNombre === null) {
        Swal.fire(
          "Ocurrio error al subir la documentación anexa, intente de nuevo."
        );
        return;
      }
      data["doc"] = nuevoNombre;
    }

    //Guardo la propuesta
    axios
      .put(`/api/propuestas/${propuesta._id}`, data)
      .then(() => {
        //Redireccionar
        Swal.fire("¡Propuesta actualizada con éxito!", "", "success");
        props.history.push("/consola");
      })
      .catch((err) => {
        Swal.fire(
          "Ocurrió un error al actualizar la propuesta, por favor inténtelo de nuevo o pónganse en contacto con el Programa Raíz.",
          "",
          "error"
        );
      });
  };

  if (loggedIn === false) return <Redirect to="/login" />;
  if (errorMunProp === true || errorUsuario === true)
    return <Redirect to="/" />;
  if (
    usuario === undefined ||
    municipio === undefined ||
    propuesta === undefined
  )
    return null;
  if (usuario.adminPropuestas === false) return <Redirect to="/consola" />;

  return (
    <MPage municipio={municipio}>
      <div className="row">
        <div className="col-md-12">
          <h1 className="ppr-titulo centrado my-2">Administrar Propuesta</h1>
          <EliminarPropuesta propuesta={propuesta} />
          <p>Formulario de edición de propuesta.</p>
          <small className=" text-muted">
            Los campos indicados con <b>*</b> son obligatorios.
          </small>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <h4 className="ppr-titulo">Sobre el Autor</h4>

            {municipio.nombreUrl !== "ballesteros2022" &&
              municipio.nombreUrl !== "ballesteros2023" &&
              municipio.nombreUrl !== "noetinger2022" &&
              municipio.nombreUrl !== "corraldebustos2022" && (
                <FormInput
                  register={register}
                  error={errors.autor}
                  label={"* Autor:"}
                  id={"autor"}
                  isRequired={true}
                  placeholder="Nombre y apellido del autor o nombre de la organización, según corresponda."
                />
              )}

            {(municipio.nombreUrl === "ballesteros2022" ||
              municipio.nombreUrl === "ballesteros2023" ||
              municipio.nombreUrl === "noetinger2022" ||
              municipio.nombreUrl === "corraldebustos2022") && (
              <FormInput
                register={register}
                error={errors.autor}
                label={"* Nombre de la organización:"}
                id={"autor"}
                isRequired={true}
                placeholder="Nombre de la organización que presenta la propuesta."
              />
            )}

            {municipio.nombreUrl !== "ballesteros2022" &&
              municipio.nombreUrl !== "ballesteros2023" &&
              municipio.nombreUrl !== "noetinger2022" &&
              municipio.nombreUrl !== "corraldebustos2022" && (
                <FormInput
                  register={register}
                  error={errors.equipo}
                  label={"Equipo:"}
                  id={"equipo"}
                  isRequired={false}
                  placeholder="De tratarse de una organización, descripción del equipo."
                />
              )}

            {(municipio.nombreUrl === "ballesteros2022" ||
              municipio.nombreUrl === "ballesteros2023" ||
              municipio.nombreUrl === "noetinger2022" ||
              municipio.nombreUrl === "corraldebustos2022") && (
              <FormInput
                register={register}
                error={errors.equipo}
                label={"* Nombre del representante:"}
                id={"equipo"}
                isRequired={true}
                placeholder="Nombre y apellido del representante de la organización que presenta la propuesta."
              />
            )}

            <FormInput
              register={register}
              error={errors.dni}
              label={"DNI:"}
              id={"dni"}
              isRequired={false}
              placeholder="De corresponder, DNI de quién presenta la propuesta."
              type="number"
            />

            <FormInput
              register={register}
              error={errors.dni}
              label={"Fecha de Nacimiento:"}
              id={"fechaNacimiento"}
              isRequired={false}
              placeholder="De corresponder, fecha de nacimiento de quién presenta la propuesta."
              type="date"
            />
            <FormInput
              register={register}
              error={errors.email}
              label={"* Email:"}
              id={"email"}
              isRequired={true}
              placeholder="Email de quién presenta la propuesta."
              type="email"
            />

            <FormInput
              register={register}
              error={errors.tel}
              label={"* Teléfono:"}
              id={"tel"}
              isRequired={true}
              placeholder="Teléfono de quién presenta la propuesta, no olvide el código de área.."
              type="tel"
            />

            <FormInput
              register={register}
              error={errors.direccion}
              label={"Dirección:"}
              id={"direccion"}
              isRequired={false}
              placeholder="De corresponder, dirección de quién presenta la propuesta."
              type="direccion"
            />

            <h4 className="ppr-titulo">Sobre la Propuesta</h4>

            <FormInput
              register={register}
              error={errors.titulo}
              label={"* Título:"}
              id={"titulo"}
              isRequired={true}
              placeholder="Título de la propuesta."
            />

            <FormInput
              register={register}
              error={errors.subtitulo}
              label={"* Sub-Título:"}
              id={"subtitulo"}
              isRequired={true}
              placeholder="Sub-título de la propuesta."
            />

            {municipio.ejes.length > 0 && (
              <div className="from-group mb-3">
                <label htmlFor="eje" className="font-weight-bold">
                  * Eje de la propuesta:
                </label>
                <select
                  type="text"
                  className="form-control"
                  id="eje"
                  defaultValue="0"
                  {...register("eje", {
                    validate: (value) => value !== "0",
                    required: true,
                  })}
                >
                  <option key="placeholder" value="0" disabled>
                    Seleccione uno de los siguientes ejes para su propuesta.
                  </option>
                  {municipio.ejes.map((eje) => (
                    <option key={eje} value={eje}>
                      {eje}
                    </option>
                  ))}
                </select>
                {errors.eje && (
                  <small className="text-danger form-text">
                    Campo Obligatorio.
                  </small>
                )}
              </div>
            )}

            <FormInput
              register={register}
              error={errors.presupuesto}
              label={"* Presupuesto:"}
              id={"presupuesto"}
              isRequired={true}
              placeholder="Monto aproximado para ejecutar la propuesta."
              type="number"
            />

            <FormTextArea
              register={register}
              error={errors.objetivos}
              label={"* Objetivos:"}
              id={"objetivos"}
              isRequired={true}
              placeholder="Detallar, de forma clara y concreta, el propósito principal que se espera alcanzar con la propuesta. Debe responder con precisión a la pregunta: “¿Qué se quiere lograr con este proyecto?”"
              rows={10}
            />

            <FormTextArea
              register={register}
              error={errors.beneficiarios}
              label={"* Beneficiarios:"}
              id={"beneficiarios"}
              isRequired={true}
              placeholder="Describir a quién o quiénes se dirige la propuesta, identificando el grupo o sector que será impactado de forma directa."
              rows={10}
            />

            <FormTextArea
              register={register}
              error={errors.laccion}
              label={"* Lugar de acción:"}
              id={"laccion"}
              isRequired={true}
              placeholder="Indicar la ubicación o área geográfica en donde se desarrollará la propuesta."
              rows={1}
            />

            <FormTextArea
              register={register}
              error={errors.resultados}
              label={"* Resultados esperados:"}
              id={"resultados"}
              isRequired={true}
              placeholder="Enunciar los beneficios tangibles e intangibles que se obtendrán con la implementación del proyecto."
              rows={10}
            />

            <FormTextArea
              register={register}
              error={errors.pejecucion}
              label={"* Periodo de ejecución:"}
              id={"pejecucion"}
              isRequired={true}
              placeholder="Indicar la duración estimada de la propuesta en meses."
              rows={1}
            />

            <FormTextArea
              register={register}
              error={errors.descripcion}
              label={"Descripción:"}
              id={"descripcion"}
              isRequired={true}
              placeholder="Descripción lo más detallada posible sobre la propuesta.."
              rows={10}
            />

            {propuesta.doc && (
              <div className="form-group ">
                <a
                  className="adminp-a"
                  href={`/api/public/${propuesta.doc}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Documentación Anexa Actual
                </a>
              </div>
            )}
            <FormInput
              register={register}
              error={errors.doc}
              label={"Documentación (un archivo pdf):"}
              id={"doc"}
              isRequired={false}
              placeholder="Documento en pdf que se adjunta a la propuesta."
              type="file"
              accept="application/pdf,application/vnd.ms-excel"
              onChange={actualizarDocumento}
            />

            <img
              src={`/api/public/${propuesta.img}`}
              className="img-fluid mx-auto d-block height-100"
              alt={propuesta.titulo}
            />

            <FormInput
              register={register}
              error={errors.doc}
              label={"Imagen (.jpg o .png)::"}
              id={"img"}
              isRequired={false}
              placeholder="Imagen que se adjunta a la propuesta."
              type="file"
              accept="image/png, image/jpeg"
              onChange={actualizarImagen}
            />

            <h4 className="ppr-titulo">
              Estado y Observaciones de la Propuesta
            </h4>

            <div className="from-group mb-3">
              <label htmlFor="estado" className="font-weight-bold">
                * Estado:
              </label>
              <select
                type="text"
                className="form-control"
                id="estado"
                {...register("estado", {
                  required: true,
                })}
              >
                <option key="pendiente" value="pendiente">
                  Dejar como pendiente
                </option>
                <option key="aceptada" value="aceptada">
                  Aceptar la propuesta para votación.
                </option>
                <option key="archivada" value="archivada">
                  Archivar la propuesta.
                </option>
                <option key="seleccionada" value="seleccionada">
                  Seleccionar la propuesta para ejecución.
                </option>
                <option key="eliminada" value="eliminada">
                  Eliminar Propuesta.
                </option>
              </select>
              {errors.eje && (
                <small className="text-danger form-text">
                  Campo Obligatorio.
                </small>
              )}
            </div>

            <FormTextArea
              register={register}
              error={errors.obs}
              label={"Agregar Observación:"}
              id={"obs"}
              isRequired={false}
              placeholder="Observación sobre los cambios realizados a la propuesta."
              rows={4}
            />
            <FormInput
              register={register}
              error={errors.ejecucion}
              label={"Actualizar estado de ejecución:"}
              id={"ejecucion"}
              isRequired={false}
              placeholder="Actualizar estado ejecución de la propuesta."
            />

            <center>
              <button
                type="submit"
                className="btn ppr-btn-verde font-weight-bold m-2 mr-5"
              >
                Guardar Cambios
              </button>
              <Link
                to={"/consola"}
                className="btn ppr-btn-verde font-weight-bold m-2"
              >
                Volver
              </Link>
            </center>
          </form>
        </div>
      </div>
    </MPage>
  );
};

export default withRouter(AdminPropuesta);
